import React, { useState, useContext } from 'react';
import CustomDropdown from './CustomDropdown';
import { BoxContext } from './BoxContext';

const AddItem = ({ shipmentItems, onAddItem, boxNumber, selectedNickname, length, width, height, weight, shipmentId, selectedPlan }) => {
  const { asinData } = useContext(BoxContext);
  const [selectedItem, setSelectedItem] = useState(null);
  const [qty, setQty] = useState('1');
  const API_URL = import.meta.env.VITE_API_URL;

  const handleAddItem = async () => {
    if (!selectedItem || !qty) {
      console.log('Please select an item and enter a quantity');
      return;
    }

    // Note: Plan selection is no longer required for adding items to boxes

    // Get the correct item weight from asinData
    const asinInfo = asinData?.find(data => data.ASIN === selectedItem.asin) || {};
    let itemWeight = asinInfo.WEIGHT || '';
    
    // Fallback: Try to get weight from OutboundItem component's weight field
    // This happens when the item has a weight set in the UI but not saved to database yet
    if (!itemWeight) {
      // Check if this item is in the OutboundItem display and has a weight there
      const matchingOutboundItem = shipmentItems?.find(si => si.item.asin === selectedItem.asin);
      if (matchingOutboundItem?.item?.weight) {
        itemWeight = matchingOutboundItem.item.weight;
        console.log('🔄 Using weight from shipmentItems as fallback:', itemWeight);
      }
    }
    
    console.log('🔍 AddItem Debug - Weight extraction:', {
      selectedAsin: selectedItem.asin,
      asinDataLength: asinData?.length || 0,
      asinInfo,
      extractedWeight: itemWeight,
      fallbackBoxWeight: weight,
      asinDataSample: asinData?.slice(0, 3), // Show first 3 items for debugging
      shipmentItemsWeight: shipmentItems?.find(si => si.item.asin === selectedItem.asin)?.item?.weight
    });
    
    // Additional debugging for the specific ASIN
    if (!itemWeight) {
      console.log('🔍 Missing Weight Debug for', selectedItem.asin, ':', {
        foundInAsinData: !!(asinInfo && Object.keys(asinInfo).length),
        asinInfo,
        matchingShipmentItem: shipmentItems?.find(si => si.item.asin === selectedItem.asin),
        allASINsInData: asinData?.map(item => item.ASIN) || []
      });
    }

    const newItem = {
      shipmentId,
      boxNumber,
      sku: selectedItem.merchant_sku,
      asin: selectedItem.asin,
      fnsku: selectedItem.fnsku,
      qty,
      length,
      width,
      height,
      title: selectedItem.title,
      weight: itemWeight, // Use the individual item weight, not the box weight
      pallet: selectedItem.pallet,
      employee: selectedNickname,
      images: selectedItem.images // Ensure this line is present
    };

    console.log('AddItem - newItem being sent:', newItem);

    // Send the new item to the server using outbound-based endpoint
    try {
      const response = await fetch(`${API_URL}/api/add_item_to_box_outbound`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newItem),
      });

      const result = await response.json();
      if (result.success) {
        console.log('Item added successfully');
        // Call the parent onAddItem function to update the state
        onAddItem(newItem);

        // Clear the quantity field but keep the selected item
        // setQty('');
      } else {
        console.error('Error adding item:', result.error);
      }
    } catch (error) {
      console.error('Error adding item:', error);
    }
  };

  const handleDropdownChange = (selectedOption) => {
    setSelectedItem(selectedOption);
    setQty('1'); // Set quantity to 1 when an item is selected
  };

  return (
    <div className="relative flex items-center gap-2 w-full">
      <div className="flex-1 min-w-0">
        <CustomDropdown
          shipmentItems={shipmentItems}
          onChange={handleDropdownChange}
          value={selectedItem ? selectedItem.asin : ''}
        />
      </div>
      <input
        type="number"
        className="w-20 h-10 px-3 text-sm text-center border border-slate-300 bg-white focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none font-medium"
        placeholder="Qty"
        value={qty}
        onChange={(e) => setQty(e.target.value)}
        onFocus={(e) => e.target.select()}
        min="1"
      />
      <button
        className="h-8 px-3 text-xs bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleAddItem}
        disabled={!selectedItem || !qty}
      >
        Add
      </button>
    </div>
  );
};

export default AddItem;
